import {InitAppForPageFn} from '@wix/yoshi-flow-editor';
import {createViewerScript} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/createViewerScript';

// This module is being used in Editor App.
// createControllers will be generated by the flow.
export const initAppForPage: InitAppForPageFn = async (initParams, apis, namespaces, platformServices) => {
  return {
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    context: await createViewerScript({}).initAppForPage(initParams, apis, namespaces, platformServices),
  };
};
